/**
 * プロジェクトのスラッグの変更の日本語（en.slug.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 * 送信元の「noreply@… のまま（到達率を守るため）」は指示書の文言の案（2026-09-28）。
 */
import type { enSlug } from './en.slug';

type SlugMessages = { [K in keyof typeof enSlug]: string };

export const jaSlug: SlugMessages = {
  'slug.title': 'URLの名前',
  'slug.lead': 'アプリのURLに入る名前です（今は「{slug}」の部分）。{days}日に1回変えられます。',
  'slug.leadDaily': 'アプリのURLに入る名前です（今は「{slug}」の部分）。1日に1回変えられます。',
  'slug.change': 'URLの名前を変える',
  'slug.nextChangeAt': '次に変えられるのは{date}からです。',
  'slug.undo': '元に戻す（{slug}へ）',
  'slug.undoNote': '{date}まで。元に戻すのは回数に数えません。',
  'slug.changed': 'URLの名前を「{slug}」に変えました。',
  'slug.changedRedirect': '{old}を使ったリンクは新しいURLへ転送されます。',
  'slug.changedNoRedirect': '{old}を使ったリンクは「見つかりません」になります。',
  'slug.tooSoon': '最近URLの名前を変えたばかりです。次に変えられるのは{date}からです。',
  'slug.accountClosed': 'このアカウントは閉鎖されているため、URLの名前は変えられません。',

  'slug.dialog.title': 'URLの名前を変える',
  'slug.dialog.newSlug': '新しい名前（URLの「neko-jump」のような部分）',
  'slug.dialog.hint': '3〜58文字で、英小文字・数字・ハイフンが使えます。',
  'slug.dialog.check': '使えるか調べる',
  'slug.dialog.suggestions': 'いま空いている名前です。押すと使えるか調べます:',
  'slug.confirm.title': '{old}を{new}に変えますか？',
  'slug.confirm.undoTitle': '元に戻す: {old}を{new}に戻しますか？',
  'slug.confirm.urlsBefore': 'いま',
  'slug.confirm.urlsAfter': '変えた後',
  'slug.confirm.customDomains': '独自ドメイン（自分のドメイン）は変わりません。',
  'slug.confirm.oldLinks': '{old}を使ったリンク（古いリンク）をどうしますか？どちらかを選んでください。',
  'slug.choice.keep': '転送を残す（古いリンクは新しいURLへ）',
  'slug.choice.keepCost': 'この古い名前1つにつき月{price}。転送を残している間、日割りで前払い残高から引きます。いつでも外せます。',
  'slug.choice.keepCostMonthly': 'この古い名前1つにつき月{price}。転送を残している間、前払い残高から引きます。いつでも外せます。',
  'slug.choice.keepCostUnknown': '転送を残している間、前払い残高から引きます。いつでも外せます。',
  'slug.choice.drop': '転送を残さない',
  'slug.choice.dropNote': '古いリンクは「見つかりません」になります。料金は掛かりません。古い名前はあなたのために取っておかれるので、あとから転送をONにできます。',
  'slug.choice.required': '進むには、古いリンクの扱いを選んでください。',
  'slug.confirm.limit': 'この変更の後、次に変えられるのは{date}からです。',
  'slug.confirm.undo': '直前の変更を取り消すので、回数に数えません。',
  'slug.confirm.noCount': 'この変更は回数に数えません。',
  'slug.confirm.mailPinned': 'メールの送信元は{address}のままです（このプロジェクトはメールを送ったことがあるため。到達率を守るため名前を変えません）。',
  'slug.confirm.mailChanges': 'メールの送信元が{before}から{after}に変わります。',
  'slug.confirm.unsubscribe': '送ったメールの配信停止のリンクは、そのまま使えます。',
  'slug.confirm.reauth': 'このあと本人の確認があります。',
  'slug.confirm.submit': 'URLの名前を変える',
  'slug.confirm.back': '戻る',

  'slug.old.title': '前に使っていたURLの名前',
  'slug.old.lead': '前に使っていた名前は、プロジェクトがある間はあなたのために取っておかれ、ほかの人は使えません（プロジェクトを削除すると、30日後に空きに戻ります）。古いリンクを今のURLへ転送するかどうかを、ここで切り替えます。',
  'slug.old.redirecting': '転送中',
  'slug.old.notFound': '「見つかりません」',
  'slug.old.retired': '{date}まで使用',
  'slug.old.perMonth': '月{price}',
  'slug.old.turnOn': '転送をONにする',
  'slug.old.turnOff': '転送をOFFにする',
  'slug.old.onTitle': '{old}を今のURLへ転送しますか？',
  'slug.old.offTitle': '{old}の転送を止めますか？',
  'slug.old.offBody': '{old}を使ったリンクは「見つかりません」になり、この転送の料金も止まります。古い名前は取っておかれるので、あとからまたONにできます。',
  'slug.old.updatedOn': '{old}を今のURLへ転送します。',
  'slug.old.updatedOff': '{old}の転送を止めました。',

  'error.redirect_choice_required': '古いリンクを転送で残すか、残さないかを選んでください。',
  'error.slug_unchanged': 'それは今のURLの名前です。',
  'error.slug_change_too_soon': '最近URLの名前を変えたばかりです。しばらくしてからお試しください。',
  'error.old_slug_not_found': 'その前のURLの名前が見つかりません。ページを読み込み直してください。'
};
